import React, { useEffect, useCallback  } from 'react';
import translate from 'react-i18next/dist/commonjs/translate';
import { useSelector, useDispatch } from 'react-redux';
import { alertSelector, closeAlert,  closeLoginFailedCountNotify} from '../../../slices/AlertSlice';
import BetslipHelper from '../../CompactView/LeftSideBarComponent/BetslipComponent/BetslipHelper';
import CommonActions from '../../../actions/CommonActions';
import { AccountsSlice } from '../../../slices/AccountsSlice';
import { EVENT } from '../../../events/listEvents';

const AlertComponent = (props) => {

  const dispatch = useDispatch()
  const {
    title,
    message,
    i18Message,
    params,
    isOpen,
    okButton,
    cancelButton,
    remindButton,
    confirmAlert,
    notifyButton,
    bodyComponent,
    className,
    ataTransferButton,
    closeButton,
    backdropClass
  } = useSelector(alertSelector)
  const isLoginPopupOpening = useSelector(state => state.AccountsSlice.isLoginPopupOpening);

  const isExistingOk = okButton && BetslipHelper.isPlaceBetEventKey(okButton.action);
  useEffect(() => {
    if (isExistingOk) {
      BetslipHelper.unFocusAllStakeInput()
      document.addEventListener('keypress', handleEnterKey, false)

      return () => {
        document.removeEventListener('keypress', handleEnterKey, false)
      }
    }
  }, [isExistingOk])

  useEffect(() => {
    const contUsNotifyElement = document.getElementById('contact-us-notify');
    if (contUsNotifyElement) {
      contUsNotifyElement.addEventListener('click', showContactUs)
      return () => {
        contUsNotifyElement.removeEventListener('click', showContactUs)
      }
    }
  },[notifyButton])

  const close = () => {
    dispatch(closeAlert())
  }

  const clickCloseIcon = () => {
    if (notifyButton && notifyButton.action) {
      window.fireEvent(notifyButton.action)
    } else if (remindButton && remindButton.action) {
      window.fireEvent(remindButton.action)
    } else if (closeButton && closeButton.action) {
      window.fireEvent(closeButton.action)
    }
    if (notifyButton && notifyButton.isLoginFailedCount) {
      dispatch(closeLoginFailedCountNotify())
    }
    close();
  }

  /**
   * Handle open FreshWidget.
   */
  const showContactUs = useCallback(() => {
    dispatch(closeAlert())
    if (notifyButton.action) {
      window.fireEvent(notifyButton.action)
    }
    CommonActions.openFreshWidget();
  }, [notifyButton, dispatch])

  const handleEnterKey = (event) => {
    if (BetslipHelper.isEnterKey(event)) {
      event.preventDefault();
      window.fireEvent((okButton).action);
      close();
    }
  }

  const handleOk = (event) => {
    if (okButton.action) {
      event.preventDefault();
      window.fireEvent(okButton.action)
    }
    close()
  }

  const handleAtaTransfer = () => {
    if (ataTransferButton.action) {
      window.fireEvent(ataTransferButton.action)
    }
    close()
  }

  const handleAcceptNotify = () => {
    if (notifyButton.action) {
      window.fireEvent(notifyButton.action)
    }
    if (notifyButton.isLoginFailedCount) {
      dispatch(closeLoginFailedCountNotify())
    }
    close();
    if(window.env.isEnableTrustCodeValidation && !isLoginPopupOpening ){
      dispatch(AccountsSlice.actions.updateLoginPopupOpening(true));
    }
  }


  const getTranslation = () => {
    if (i18Message){
      return i18Message;
    }
    const payload = {}
    if (params.length > 0) {
      params.forEach((param, index) => {
        payload[index] = param;
      })
    }
    if (Object.keys(payload).length > 0) {
      if (payload[0].nsSeparator) {
        return props.t(message, payload[0])
      }
      return props.t(message, payload)
    }
    return props.t(message)
  }

  function handleRemind () {
    if (remindButton.action) {
      window.fireEvent(remindButton.action)
    }
    close()
  }

  function handleCancel () {
    if (cancelButton.action) {
      window.fireEvent(cancelButton.action)
    }
    close()
  }

  function getButtons (){
    const buttonArray = [];
    if (ataTransferButton) {
      buttonArray.push(<button key="a-notifyBtn" type="button" className="ataTransferBtn" onClick={handleAtaTransfer}>{props.t(ataTransferButton.text)}</button>)
      return buttonArray;
    }
    if (okButton){
      buttonArray.push(<button autoFocus key="a-okBtn" type="button" className="okBtn" onClick={handleOk}>{props.t(okButton.text)}</button>)
    }
    if (cancelButton){
      buttonArray.push(<button key="a-cancelBtn" type="button" className="cancelBtn" onClick={handleCancel}>{props.t(cancelButton.text)}</button>)
    }
    if (remindButton){
      buttonArray.push(<button key="a-remindBtn" type="button" className="cancelBtn remindBtn" onClick={handleRemind}>{props.t(remindButton.text)}</button>)
    }
    if (notifyButton) {
      buttonArray.push(<button autoFocus={true} key="a-notifyBtn" type="button" className="okBtn notifyBtn" onClick={handleAcceptNotify}>{props.t(notifyButton.text)}</button>)
    }
    return buttonArray;
  }

  const classAlert = `AlertComponent ${className} ${remindButton ? " remind-alert" : ""}${confirmAlert ? " confirm-alert" : ""}${notifyButton ? ' notify-alert' : ''}${ataTransferButton ? ' ata-transfer-alert' : ''}${title === 'default:Error' ? 'load-game-error': ''}`;
  const classAlertAciton = `alert-action ${remindButton ? "remind-action" : ""} ${confirmAlert ? "confirm-action" : ""} ${notifyButton ? 'notify-action' : ''}`;
  return(
    <React.Fragment>
      {
        isOpen ?
            <React.Fragment>
              <div className={`modal-backdrop in ${backdropClass}`} />
			  <div className={`alert-overlay ${notifyButton ? 'notify-alert' : ''}`}>
				<div className={classAlert}>
				  <div className="header">
					{title && <span className="title">{props.t(title)}</span>}
					<i onClick={clickCloseIcon} className="fal fa-times close"></i>
				  </div>
				  <div className="alert-message" dangerouslySetInnerHTML={{ __html: getTranslation() }}>
				  </div>
				  { bodyComponent ? bodyComponent : null }
				  <div className={classAlertAciton}>
					{
					  getButtons()
					}
				  </div>
				</div>
			  </div>
            </React.Fragment>
        : null
      }
    </React.Fragment>

  )
}

AlertComponent.defaultProps = {
  isActionButton: false,
}


export default translate()(AlertComponent);



// WEBPACK FOOTER //
// ./src/app/components/BaseComponent/AlertComponent/index.js